import $ from 'jquery';
import 'slick-carousel';

class Slider {
    constructor(elem) {
        this.elem = elem;
        this.breakpoints = {
            'screen-xs': 576,
            'screen-sm': 768,
            'screen-md': 992,
            'screen-lg': 1260,
            'screen-xl': 1440,
        };
        this.slider = this.elem.querySelector('.logo-slider__slide-container');
    }

    init() {
        if (!this.elem.classList.contains('logo-slider--grid')) {
            const settings = this.assembleSliderSettings();

            if (this.slider.querySelectorAll('.logo-slider__item').length > 2) {
                $(this.slider).slick(settings);
            }
        }
    }

    assembleSliderSettings() {
        const buttonNextText = this.elem.getAttribute('data-slider-button-next');
        const buttonPrevText = this.elem.getAttribute('data-slider-button-prev');
        const arrows = this.elem.getAttribute('data-arrows')
            ? JSON.parse(this.elem.getAttribute('data-arrows').toLowerCase()) : false;

        const settings = {
            accessibility: true,
            mobileFirst: true,
            slidesToShow: 2,
            slidesToScroll: 1,
            infinite: true,
            autoplay: true,
            dots: true,
            autoplaySpeed: 2000,
            arrows,
            prevArrow: `<button class="slick-prev slick-arrow" type="button">${buttonPrevText}</button>`,
            nextArrow: `<button class="slick-next slick-arrow" type="button">${buttonNextText}</button>`,
            responsive: [
                {
                    breakpoint: this.breakpoints['screen-xs'], // https://github.com/kenwheeler/slick/issues/2503
                    settings: {
                        slidesToShow: 3,
                    },
                },
                {
                    breakpoint: this.breakpoints['screen-sm'], // https://github.com/kenwheeler/slick/issues/2503
                    settings: {
                        slidesToShow: 4,
                    },
                },
                {
                    breakpoint: this.breakpoints['screen-md'], // https://github.com/kenwheeler/slick/issues/2503
                    settings: {
                        slidesToShow: 6,
                    },
                },
                {
                    breakpoint: this.breakpoints['screen-lg'], // https://github.com/kenwheeler/slick/issues/2503
                    settings: {
                        slidesToShow: 7,
                    },
                },
            ],
        };

        if (this.elem.closest('.tabs')) {
            settings.slidesToShow = 3;
            settings.responsive = [
                {
                    breakpoint: this.breakpoints['screen-xs'], // https://github.com/kenwheeler/slick/issues/2503
                    settings: {
                        slidesToShow: 4,
                    },
                },
                {
                    breakpoint: this.breakpoints['screen-sm'], // https://github.com/kenwheeler/slick/issues/2503
                    settings: {
                        slidesToShow: 3,
                    },
                },
                {
                    breakpoint: this.breakpoints['screen-md'], // https://github.com/kenwheeler/slick/issues/2503
                    settings: {
                        slidesToShow: 4,
                    },
                },
                {
                    breakpoint: this.breakpoints['screen-lg'], // https://github.com/kenwheeler/slick/issues/2503
                    settings: {
                        slidesToShow: 5,
                    },
                },
            ];
        }

        $(this.elem).on('init reInit afterChange', (event, slick, currentSlide = 0) => {
            const i = currentSlide + 1;
            $(this.elem).find('.logo-slider__info-current').text(i.toString().padStart(2, '0'));
        });

        return settings;
    }
}

export default Slider;
